import React from "react";
import { components as rsComponents } from "react-select";
import { useLayoutContext } from "./LayoutContext";

/**
 * @deprecated This component is being removed in V6+, February 2025, in favor of the `SelectV2/MultiSelectV2` components.
 */
export const MenuPortal = _ref => {
  let {
    children,
    ...props
  } = _ref;
  // Just by using this context here, we'll re-render this component when the
  // context value changes. We don't actually need to use anything here,
  // just force a re-render to reposition the portaled menu.
  useLayoutContext();
  return /*#__PURE__*/React.createElement(rsComponents.MenuPortal, props, children);
};
//# sourceMappingURL=MenuPortal.js.map